import React, { ReactElement, useEffect, useState } from 'react';
import Select from 'src/components/common/Select';
import { SelectValue } from 'antd/lib/select';
import { Alert } from 'antd';
import { useOptionsFiltersFetching } from '../hooks';
import Accordion from 'src/components/common/Accordion';
import Spin from 'src/components/common/Spin';
import styles from './RegionFilter.module.less';

const { OptGroup, Option } = Select;

const onSearchFilter = (input: string, option: ReactElement) => {
  const text = String(option?.props?.children ?? '');
  return text.toLowerCase().includes(input.toLowerCase());
};

type SiteFilterProps = {
  onChange: Function;
  sourceOwnerId: string;
  selectedSites: number;
  header?: string;
  selectedItems?: SelectValue;
  defaultValue?: Array<SelectValue>;
};

const RegionFilter: React.FC<SiteFilterProps> = ({ onChange, sourceOwnerId, selectedSites, header = 'Region' }) => {
  const { data: dataRegionRes, loading, error } = useOptionsFiltersFetching(sourceOwnerId);
  const responseLoaded = !loading && (dataRegionRes || error);
  const regionsOptions = (dataRegionRes && dataRegionRes.Regions) || [];
  const [selectedItems, setSelectedItems] = useState<SelectValue>();

  useEffect(() => {
    if (JSON.stringify(selectedSites) !== JSON.stringify(selectedItems)) {
      setSelectedItems(selectedSites);
    }
  }, [selectedSites]);

  const onSiteChange = (value: SelectValue): void => {
    setSelectedItems(value);
    onChange('region', value);
  };

  return (
    <Accordion header={header}>
      <div className={styles.wrapper}>
        {loading && <Spin spinning={loading} />}
        {responseLoaded &&
          (error ? (
            <Alert
              message="An error has occurred when trying to get filter list! Please try again later!"
              type="error"
              showIcon
            />
          ) : (
            <Select
              showArrow={true}
              placeholder="Select Region (Default All)"
              onChange={onSiteChange}
              value={selectedItems}
              allowClear
              showSearch
              filterOption={onSearchFilter}
              maxTagCount={1}
              className={styles.select}
            >
              {regionsOptions &&
                regionsOptions.length > 0 &&
                regionsOptions.map(({ regionGroupName, region }, i) => {
                  return (
                    <OptGroup key={`optGroup_${regionGroupName}_${i}`} label={regionGroupName}>
                      {region.map(({ value, label, title }) => {
                        return (
                          <Option key={`region_${value}_${i}`} value={value} title={title}>
                            {label}
                          </Option>
                        );
                      })}
                    </OptGroup>
                  );
                })}
            </Select>
          ))}
      </div>
    </Accordion>
  );
};

export default RegionFilter;
